import { InjectionToken } from '@angular/core';
/**
 * Injection token that can be used to provide the array of sidebar items for an application.
 */
export const GOOGLE_MAPS_KEY = new InjectionToken<string>('GOOGLE_MAPS_KEY');
